import FlashingDots from "./FlashingDots";

export default FlashingDots;
